function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB45F"
    },
    d: "M212.666,194.207c-61.603,0-113.664-44.104-123.789-104.879l-0.285-1.689 c-1.112-6.673,0.629-13.129,4.905-18.173c4.13-4.879,10.178-7.672,16.596-7.672h53.164V35.31h-53.164 c-14.216,0-27.629,6.207-36.802,17.035c-9.255,10.931-13.198,25.379-10.819,39.663l0.285,1.681 c12.259,73.596,75.303,127,149.906,127c0,0,0.018,0,0.022,0v-26.483C212.675,194.207,212.675,194.207,212.666,194.207z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC36E"
    },
    d: "M438.71,52.345c-9.173-10.828-22.586-17.035-36.802-17.035h-53.164v26.483h53.164 c6.418,0,12.466,2.793,16.595,7.672c4.276,5.043,6.017,11.5,4.905,18.173l-0.285,1.689 c-10.124,60.776-62.185,104.879-123.788,104.879c-0.009,0-0.009,0-0.018,0v26.483c0.004,0,0.018,0,0.018,0 c74.607,0,137.651-53.405,149.909-127l0.285-1.681C451.909,77.725,447.964,63.276,438.71,52.345z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC36E"
    },
    points: "282.483,414.897 229.518,414.897 238.345,229.517 273.656,229.517  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBB45F"
    },
    points: "238.345,229.517 229.518,414.897 256,414.897 256,229.517 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD782"
    },
    d: "M308.966,450.207H203.035v-35.31c0-4.875,3.953-8.828,8.828-8.828h88.276 c4.875,0,8.828,3.953,8.828,8.828V450.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC36E"
    },
    d: "M256,406.069h-44.138c-4.875,0-8.828,3.953-8.828,8.828v35.31h44.138v-35.31 C247.173,410.022,251.125,406.069,256,406.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B5A50"
    },
    d: "M344.276,467.862H167.724l12.414-18.621c3.274-4.911,8.787-7.862,14.69-7.862h122.344 c5.903,0,11.415,2.951,14.69,7.862L344.276,467.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#874641"
    },
    d: "M247.794,441.379h-52.966c-5.903,0-11.415,2.95-14.69,7.862l-12.414,18.621h52.966l12.414-18.621 C236.379,444.329,241.891,441.379,247.794,441.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA6455"
    },
    d: "M344.276,512H167.724c-4.875,0-8.828-3.953-8.828-8.828v-35.31c0-4.875,3.953-8.828,8.828-8.828 h176.552c4.875,0,8.828,3.953,8.828,8.828v35.31C353.104,508.047,349.151,512,344.276,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B5A50"
    },
    d: "M220.69,503.172v-35.31c0-4.875,3.953-8.828,8.828-8.828h-61.793c-4.875,0-8.828,3.953-8.828,8.828 v35.31c0,4.875,3.953,8.828,8.828,8.828h61.793C224.643,512,220.69,508.047,220.69,503.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD782"
    },
    d: "M326.339,204.235l-39.073,30.39c-3.1,2.41-6.913,3.719-10.839,3.719h-40.851 c-3.926,0-7.741-1.309-10.839-3.719l-39.073-30.39c-22.741-17.688-37.298-43.875-40.313-72.527L132.414,8.828h247.172 l-12.935,122.88C363.636,160.36,349.079,186.548,326.339,204.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC36E"
    },
    d: "M254.726,234.625l-18.141-30.39c-10.559-17.688-17.316-43.875-18.717-72.529L211.862,8.828h-79.448 l12.935,122.88c3.016,28.652,17.572,54.84,40.313,72.529l39.073,30.39c3.1,2.411,6.913,3.72,10.839,3.72h24.183 C257.936,238.345,256.165,237.036,254.726,234.625z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD782"
    },
    d: "M379.587,17.655H132.414c-4.875,0-8.828-3.953-8.828-8.828l0,0c0-4.875,3.953-8.828,8.828-8.828 h247.172c4.875,0,8.828,3.953,8.828,8.828l0,0C388.414,13.703,384.462,17.655,379.587,17.655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD782"
    },
    d: "M282.483,300.138h-52.966c-4.875,0-8.828-3.953-8.828-8.828v-8.828c0-4.875,3.953-8.828,8.828-8.828 h52.966c4.875,0,8.828,3.953,8.828,8.828v8.828C291.311,296.185,287.358,300.138,282.483,300.138z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC36E"
    },
    d: "M247.173,291.31v-8.828c0-4.875,3.953-8.828,8.828-8.828h-26.483c-4.875,0-8.828,3.953-8.828,8.828 v8.828c0,4.875,3.953,8.828,8.828,8.828H256C251.125,300.138,247.173,296.185,247.173,291.31z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC36E"
    },
    points: "376.799,35.31 378.657,17.655 133.343,17.655 135.201,35.31  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBB45F"
    },
    points: "212.294,17.655 133.343,17.655 135.201,35.31 213.157,35.31 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC36E"
    },
    d: "M203.035,8.828c0-4.875,3.953-8.828,8.828-8.828h-79.448c-4.875,0-8.828,3.953-8.828,8.828 s3.953,8.828,8.828,8.828h79.448C206.987,17.655,203.035,13.703,203.035,8.828z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M361.475,44.658c-13.173-3.004-23.543-13.373-26.546-26.546c-0.226-0.992-1.539-0.992-1.766,0 c-3.004,13.173-13.373,23.543-26.546,26.546c-0.992,0.226-0.992,1.539,0,1.766c13.173,3.004,23.543,13.373,26.546,26.546 c0.226,0.992,1.539,0.992,1.766,0c3.004-13.173,13.373-23.543,26.546-26.546C362.467,46.198,362.467,44.884,361.475,44.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.83,84.564c-9.274-2.402-16.577-9.705-18.979-18.979c-0.242-0.931-1.447-0.931-1.688,0 c-2.402,9.274-9.705,16.577-18.979,18.979c-0.931,0.242-0.931,1.447,0,1.688c9.274,2.402,16.577,9.704,18.979,18.979 c0.242,0.931,1.447,0.931,1.688,0c2.402-9.276,9.705-16.577,18.979-18.979C323.761,86.012,323.761,84.806,322.83,84.564z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyIcon);
export default __webpack_public_path__ + "static/media/trophy-icon.313ecd6285cb6dfff5e5185cc18d93e6.svg";
export { ForwardRef as ReactComponent };